<template>
  <span
    slot="header"
    class="dea-tab-child dea-links dea-links--large dea-links--no-border dea-links--chip dea-tabs__tab"
  >
    <input
      :id="`tab-${id}-trigger`"
      :name="`tab-${id}`"
      type="radio"
      :data-item="id"
      :data-target="`tab-content-${id}`"
      class="dea-tabs-single__input"
      @change="selectMethod($event, id)"
    />
    <label
      :for="`tab-${id}-trigger`"
      class="dea-tab-child__label dea-heading--medium__m dea-links__label"
      :class="targetBorder"
    >
      {{ label }}
      <i v-if="selectedTabId !== id" class="dea-ico-go-to"></i>
    </label>
  </span>
</template>

<script>
export default {
  name: "LightTabChild",
  props: {
    id: {
      type: Number,
      default: 0,
    },
    label: {
      type: String,
      default: "",
    },
    targetBorder: {
      type: String,
      default: "",
    },
    selectMethod: {
      type: Function,
      required: true,
    },
    selectedTabId: {
      type: Number,
      default: null,
    },
  },
};
</script>

<style lang="scss">
@import "~deascuola-storybook/src/styles/system.utils";

.dea-tab-child {
  &__label {
    font-size: $h_font-size-large !important; // sass-lint:disable-line no-important, variable-name-format
  }

  .dea-border-target-generic {
    border-bottom: $border-bold $dea-color-black !important; // sass-lint:disable-line no-important
  }
}
</style>
